import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, X, ChevronLeft, ChevronRight, Scale, FileText, AlertOctagon, ClipboardCheck, Search, Mail, Briefcase, Users } from 'lucide-react';
const slides = [{
  icon: Scale,
  title: 'Sumario Administrativo',
  desc: 'Cómo funciona un sumario hospitalario y tus derechos en cada etapa.',
  image: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?auto=format&fit=crop&w=1200&h=700&q=80'
}, {
  icon: FileText,
  title: 'Descargo ante Sumario',
  desc: 'Plantilla completa de descargo con modelo resuelto paso a paso.',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1200&h=700&q=80'
}, {
  icon: AlertOctagon,
  title: 'Denuncia Penal',
  desc: 'Protocolo de acción: los primeros 5 pasos en las primeras 48 horas.',
  image: 'https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=1200&h=700&q=80'
}, {
  icon: ClipboardCheck,
  title: 'Documentación Preventiva',
  desc: '4 plantillas diarias de alto valor legal que la mayoría no usa.',
  image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1200&h=700&q=80'
}, {
  icon: Search,
  title: 'Auditoría Interna Mensual',
  desc: 'Checklist para revisar tu exposición antes de que lo haga otro.',
  image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&h=700&q=80'
}, {
  icon: Mail,
  title: 'Comunicaciones Formales',
  desc: 'Plantillas: notas a jefatura, respuestas al juez, cartas documento.',
  image: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&w=1200&h=700&q=80'
}, {
  icon: Briefcase,
  title: 'Seguro Responsabilidad Civil',
  desc: 'Manejo del seguro médico: qué cubre y qué no, paso a paso.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1200&h=700&q=80'
}, {
  icon: Users,
  title: 'Apoyo al Médico Denunciado',
  desc: 'Recursos y organismos de apoyo en Argentina cuando lo necesitás.',
  image: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?auto=format&fit=crop&w=1200&h=700&q=80'
}];
export function UpgradeElite() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => {
      setIndex(prev => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [paused]);
  const next = () => setIndex(prev => (prev + 1) % slides.length);
  const prev = () => setIndex(p => (p - 1 + slides.length) % slides.length);
  const handleDragEnd = (e: any, {
    offset
  }: any) => {
    if (offset.x < -50) next();else if (offset.x > 50) prev();
  };
  const current = slides[index];
  const CurrentIcon = current.icon;
  return <section className="py-10 md:py-20 bg-brand-dark relative overflow-hidden" data-id="element-323">
      {/* Decorative gold glow */}
      <div className="absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, #D4AF37 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-324"></div>
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-325"></div>
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-brand-mid/20 rounded-full blur-3xl" data-id="element-326"></div>

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-327">
        {/* Header */}
        <div className="text-center mb-6 md:mb-10" data-id="element-328">
          <div className="inline-flex items-center gap-2 bg-brand-gold/15 border border-brand-gold/30 px-3 py-1 rounded-full text-[11px] md:text-sm font-bold text-brand-gold tracking-widest uppercase mb-3 md:mb-4" data-id="element-329">
            <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-330" />
            UPGRADE ELITE
          </div>
          <h2 className="font-heading text-[24px] md:text-5xl text-white mb-2 md:mb-4 leading-tight" data-id="element-331">
            ¿Qué agrega el{' '}
            <span className="text-brand-gold" data-id="element-332">Blindaje Legal Total</span>?
          </h2>
          <p className="text-blue-200 text-xs md:text-lg max-w-2xl mx-auto" data-id="element-333">
            Para psiquiatras que no pueden permitirse perder la matrícula
          </p>
        </div>

        {/* Sin / Con Elite compact comparison */}
        <div className="grid grid-cols-2 gap-2 md:gap-4 mb-6 md:mb-10 max-w-3xl mx-auto" data-id="element-334">
          <div className="bg-red-950/40 border border-red-500/30 p-3 md:p-5 rounded-xl backdrop-blur-sm" data-id="element-335">
            <div className="flex items-center gap-1.5 mb-1.5 md:mb-2" data-id="element-336">
              <X className="w-3.5 h-3.5 md:w-4 md:h-4 text-red-400 shrink-0" data-id="element-337" />
              <h3 className="font-bold text-red-300 text-[11px] md:text-sm uppercase tracking-wider" data-id="element-338">
                Sin Elite
              </h3>
            </div>
            <p className="text-[11px] md:text-sm text-red-100/80 leading-snug" data-id="element-339">
              Si te denuncian, no sabés qué hacer en las primeras 48 horas. Sin
              escudo legal preventivo.
            </p>
          </div>
          <div className="bg-brand-gold/10 border border-brand-gold/40 p-3 md:p-5 rounded-xl backdrop-blur-sm" data-id="element-340">
            <div className="flex items-center gap-1.5 mb-1.5 md:mb-2" data-id="element-341">
              <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold shrink-0" data-id="element-342" />
              <h3 className="font-bold text-brand-gold text-[11px] md:text-sm uppercase tracking-wider" data-id="element-343">
                Con Elite
              </h3>
            </div>
            <p className="text-[11px] md:text-sm text-yellow-50/90 leading-snug" data-id="element-344">
              Sistema completo: descargo, protocolo penal, auditoría mensual y
              plantillas formales.
            </p>
          </div>
        </div>

        {/* Premium "Elite includes" callout */}
        <div className="text-center mb-4 md:mb-6" data-id="element-345">
          <div className="inline-flex items-center gap-2 text-brand-gold font-bold text-[10px] md:text-sm tracking-widest uppercase mb-1 md:mb-2" data-id="element-346">
            <span className="h-px w-8 md:w-12 bg-brand-gold/50" data-id="element-347"></span>
            EL ELITE INCLUYE
            <span className="h-px w-8 md:w-12 bg-brand-gold/50" data-id="element-348"></span>
          </div>
          <h3 className="font-heading text-lg md:text-3xl text-white" data-id="element-349">
            Blindaje Legal Total{' '}
            <span className="text-brand-gold" data-id="element-350">— 50 páginas premium</span>
          </h3>
        </div>

        {/* SLIDER */}
        <div className="relative max-w-3xl mx-auto" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-id="element-351">
          {/* Card */}
          <div className="relative bg-white rounded-2xl overflow-hidden shadow-2xl border-2 border-brand-gold/30" data-id="element-352">
            <AnimatePresence mode="wait" data-id="element-353">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 30
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -30
            }} transition={{
              duration: 0.4
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} onDragEnd={handleDragEnd} className="cursor-grab active:cursor-grabbing" data-id="element-354">
                {/* Image */}
                <div className="relative aspect-[16/9] md:aspect-[21/9] bg-gray-100 overflow-hidden" data-id="element-355">
                  <img src={current.image} alt={current.title} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" data-id="element-356" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/40 to-transparent" data-id="element-357"></div>

                  {/* Item counter */}
                  <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-brand-gold/95 backdrop-blur-sm text-brand-dark text-[10px] md:text-xs font-bold px-2 py-1 md:px-3 md:py-1.5 rounded-full shadow-lg" data-id="element-358">
                    {String(index + 1).padStart(2, '0')} /{' '}
                    {String(slides.length).padStart(2, '0')}
                  </div>

                  {/* Icon badge over image */}
                  <div className="absolute bottom-3 left-3 md:bottom-5 md:left-5 bg-white/15 backdrop-blur-md border border-white/30 rounded-xl p-2 md:p-3 shadow-lg" data-id="element-359">
                    <CurrentIcon className="w-5 h-5 md:w-7 md:h-7 text-brand-gold" data-id="element-360" />
                  </div>
                </div>

                {/* Text */}
                <div className="p-4 md:p-6" data-id="element-361">
                  <h4 className="font-heading text-base md:text-2xl text-brand-dark mb-1 md:mb-2 leading-tight" data-id="element-362">
                    {current.title}
                  </h4>
                  <p className="text-xs md:text-base text-gray-600 leading-relaxed" data-id="element-363">
                    {current.desc}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Arrows */}
            <button onClick={prev} aria-label="Anterior" className="absolute left-1.5 md:left-3 top-1/3 -translate-y-1/2 bg-white/90 hover:bg-white text-brand-dark p-1.5 md:p-2 rounded-full shadow-lg backdrop-blur-sm transition-all active:scale-90 z-10" data-id="element-364">
              <ChevronLeft className="w-4 h-4 md:w-5 md:h-5" data-id="element-365" />
            </button>
            <button onClick={next} aria-label="Siguiente" className="absolute right-1.5 md:right-3 top-1/3 -translate-y-1/2 bg-white/90 hover:bg-white text-brand-dark p-1.5 md:p-2 rounded-full shadow-lg backdrop-blur-sm transition-all active:scale-90 z-10" data-id="element-366">
              <ChevronRight className="w-4 h-4 md:w-5 md:h-5" data-id="element-367" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-1.5 mt-4 md:mt-5" data-id="element-368">
            {slides.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Slide ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === index ? 'w-6 md:w-8 bg-brand-gold' : 'w-1.5 bg-white/30 hover:bg-white/50'}`} data-id="element-369" />)}
          </div>

          {/* Thumbnail rail — desktop only */}
          <div className="hidden md:flex justify-center gap-2 mt-5 flex-wrap" data-id="element-370">
            {slides.map((s, i) => {
            const Icon = s.icon;
            return <button key={i} onClick={() => setIndex(i)} aria-label={s.title} className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all ${i === index ? 'bg-brand-gold text-brand-dark shadow-md scale-105' : 'bg-white/5 text-white/60 hover:bg-white/10 hover:text-white border border-white/10'}`} data-id="element-371">
                  <Icon className="w-3.5 h-3.5" data-id="element-372" />
                  <span data-id="element-373">{s.title}</span>
                </button>;
          })}
          </div>

          <p className="text-center text-[10px] md:text-xs text-white/40 mt-3 md:hidden" data-id="element-374">
            Deslizá para ver más
          </p>
        </div>
      </div>
    </section>;
}